import { useState, useEffect, useCallback, useRef } from 'react';

const useSpeechRecognition = () => {
	const [transcript, setTranscript] = useState('');
	const [isListening, setIsListening] = useState(false);
	const [error, setError] = useState<string | null>(null);

	// Verificar la compatibilidad del navegador
	const SpeechRecognition =
		window.SpeechRecognition || window.webkitSpeechRecognition;
	const recognition = useRef<SpeechRecognition | null>(null);

	useEffect(() => {
		if (!recognition.current && SpeechRecognition) {
			recognition.current = new SpeechRecognition();
			recognition.current.lang = 'es-ES';
			recognition.current.continuous = true;
			// ... configurar otros eventos
		}
	}, []);

	useEffect(() => {
		if (!recognition.current) {
			setError('Speech Recognition no es compatible con este navegador');
			return;
		}

		// Configuración del reconocimiento de voz
		// recognition.continuous = true;
		// recognition.current.continuous = true;
		// recognition.interimResults = true;
		recognition.current.lang = 'es-ES'; // Puedes cambiar el idioma según necesites

		// Evento cuando se reconoce el habla
		recognition.current.onresult = (event) => {
			const currentTranscript = Array.from(event.results)
				.map((result) => result[0])
				.map((result) => result.transcript)
				.join('');

			setTranscript(currentTranscript);
		};

		// Manejo de errores
		recognition.current.onerror = (event) => {
			setError(event.error);
			setIsListening(false);
		};

		// Evento cuando termina el reconocimiento
		recognition.current.onend = () => {
			setIsListening(false);
		};

		return () => {
			if (recognition.current) {
				recognition.current.stop();
			}
		};
	}, [recognition]);

	const audio = new Audio(process.env.PUBLIC_URL + '/alert.mp3');
	// Iniciar reconocimiento de voz
	const startListening = useCallback(() => {
		audio.play();
		if (recognition.current) {
			try {
				recognition.current.start();
				setIsListening(true);
				setError(null);
			} catch (err: any) {
				setError(err.message);
				setIsListening(false);
			}
		}
	}, [recognition]);

	// Detener reconocimiento de voz
	const stopListening = useCallback(() => {
		if (recognition.current) {
			recognition.current.stop();
			audio.play();
			setIsListening(false);
		}
	}, [recognition]);

	// Limpiar transcripción
	const resetTranscript = useCallback(() => {
		setTranscript('');
	}, []);

	return {
		transcript,
		isListening,
		startListening,
		stopListening,
		resetTranscript,
		error,
	};
};

export default useSpeechRecognition;
